import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the AksesuareklemodalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-aksesuareklemodal',
  templateUrl: 'aksesuareklemodal.html',
})
export class AksesuareklemodalPage {
  aciklama:any={ID:-1,Name:"",Type:3};

  constructor(public navCtrl: NavController,
    public ortak:Ortak,
    public bllOrtak:BllOrtak,
    public viewCtrl:ViewController,
     public navParams: NavParams) {
  }

  ionViewDidLoad() {

  }

  boslukKontrol() {
    var mesaj = "";
    
    if (this.aciklama.Name == null || this.aciklama.Name == "") {
      mesaj = mesaj + "Lütfen Açıklama adını giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }

  kaydet() {

    var formData = new FormData();
   
    if (this.boslukKontrol()) {
      formData.append("Aciklama_json", JSON.stringify(this.aciklama));
     
      this.bllOrtak.islem(formData, "AciklamaEkleGuncelle", "", false).then(a => {
        var sonuc = <any>a;
        if(sonuc.Sonuc==1) this.ortak.showBasicAlert("Başarılı","İşlem Başarılı");
       

      })
    }
    this.cikis();
    }


    cikis()
    {
      this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/aksesuareklemodal/aksesuareklemodal.ts